// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__J9MNv","hero-background":"hero_hero-background__wJk1Q"};